import { Timeline, TimelineItem, timelineItemClasses, TimelineSeparator, TimelineConnector, TimelineDot, TimelineContent } from "@mui/lab";

import { Box, Icon, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { Log } from "../../data/interfaces/jobmodels";
import { useEffect, useState } from "react";
import jobService from "../../data/api/job.service";
import { DropdownModel } from "../../data/interfaces/sharedmodels";

export default function JobLogs({ logs }: { logs: Log[] }) {
    const [logType, setLogType] = useState(0);
    const [logTypes,setLogTypes]=useState<DropdownModel[]>([])
    const [tasks, setTasks] = useState<{ TaskId: number, TableNo: string, Nlc: number }[]>([]);
    useEffect(() => {
        jobService.getJobLogTypes().then((response) => {
            setLogTypes(response.data);
            setLogType(response.data[0].Id)
        });

    }, []);
    useEffect(() => {
        if(logTypes&&logTypes.length)
            setLogType(Number.parseInt( logTypes[2].Id))

    }, [logTypes]);
    useEffect(() => {
        let tempTasks = logs.filter(f => f.TaskId != null).map(a => { return { TaskId: a.TaskId, TableNo: a.TaskTableNo, Nlc: a.Nlc } });
        let uniqueTasks = [...new Set(tempTasks.map(o => JSON.stringify(o)))].map(s => JSON.parse(s));
        setTasks(uniqueTasks);
    }, [logs]);
    const handleChange = (event: SelectChangeEvent) => {
        let type = Number.parseInt(event.target.value);
        setLogType(type);
    };
    const [selectedTask, setSelectedTask] = useState(-99);
    const handleTaskChange = (event: SelectChangeEvent) => {
        let taskId = Number.parseInt(event.target.value);
        setSelectedTask(taskId);
    };
    return (
        <Box >
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: -3 }}>
                
                <Box sx={{display:'flex',justifyContent:'flex-start'}}>
                <Typography sx={{ mr: 2, mt: 1 }}>Select Task :</Typography>
                    <Select defaultValue={"-99"} onChange={handleTaskChange} size="small">
                        <MenuItem key={-99} value={-99}>All</MenuItem>
                        {
                            tasks.map((a) => {
                                return (
                                    <MenuItem key={a.TaskId} value={a.TaskId}>{a.Nlc ?? "Global"} - {a.TableNo}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </Box>
                <Box sx={{display:'flex',justifyContent:'flex-start'}}>
                    <Typography sx={{  ml: 2,mr: 2, mt: 1 }}>Select Log Level to Show :</Typography>
                    <Select value={logType.toString()} onChange={handleChange} size="small">
                        {
                            logTypes.map((a, index) => {
                                return (
                                    <MenuItem  key={a.Id} value={a.Id}>{a.Description}</MenuItem>
                                )
                            })
                        }
                    </Select>
                    
                </Box>
            </Box>
            <Timeline
                sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                        flex: 0,
                        padding: 0,
                    },
                }}
            >
                {
                    logs.filter(l => (selectedTask < 1 || l.TaskId == selectedTask) && l.TypeId <= logType).map((logitem) => {
                        return (
                            <TimelineItem key={logitem.Id} >
                                <TimelineSeparator>
                                    <TimelineConnector />
                                    <TimelineDot color="primary">
                                    <Icon>{logitem.Icon}</Icon>
                                    </TimelineDot>
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent sx={{ display: 'inline-grid' }}>

                                    <Typography>{logitem.Description}</Typography>
                                    <Typography sx={{ fontSize: '14px' }}>{logitem.DateCreated}</Typography>
                                </TimelineContent>
                            </TimelineItem>
                        );
                    })
                }

            </Timeline>
        </Box>
    );
}